// Query keys are used to identify & cache the keys in react-query.
// All query keys are unique, and should be defined in this file.
export enum QueryKeys {
  BOOKING = 'booking', // Single item
  BOOKINGS = 'bookings', // List item
  SHIFT = 'SHIFT',
  SHIFTS = 'SHIFTS',
}
